// constants/productCardConstants.ts
const PRODUCT_CARD_CONSTANTS = {
    WEBPAGE_HORIZONTAL_WIDTH: '300px',
    WEBPAGE_VERTICAL_WIDTH: '200px',
    // Default width values (used as fallback when no dynamic configuration)
    DEFAULT_HORIZONTAL_WIDTH: 450,
    DEFAULT_VERTICAL_WIDTH: 150,
    // Dynamic breakpoint calculation: configured width + BREAKPOINT_OFFSET
    BREAKPOINT_OFFSET: 45,
};
export const getFinalOrientation = (windowWidth, userOrientation, horizontalWidth) => {
    // Use provided width or fallback to default
    const hWidth = horizontalWidth ?? PRODUCT_CARD_CONSTANTS.DEFAULT_HORIZONTAL_WIDTH;
    // Calculate force vertical breakpoint (only one needed for orientation logic)
    const fvBreakpoint = hWidth + PRODUCT_CARD_CONSTANTS.BREAKPOINT_OFFSET;
    // If screen is wide enough, respect user choice
    if (windowWidth >= fvBreakpoint) {
        return userOrientation;
    }
    // If screen is too narrow, force vertical regardless of user choice
    return 'vertical';
};
export default PRODUCT_CARD_CONSTANTS;
//# sourceMappingURL=productCardConstants.js.map